// Google Play Billing via the Digital Goods API (only works inside the
// installed Android TWA). On the web these helpers no-op.
const STORE = "https://play.google.com/billing";

export const SKUS = { monthly: "premium_monthly", annual: "premium_yearly" };
const ALL_SKUS = [SKUS.monthly, SKUS.annual];

export function isAppBilling() {
  return typeof window !== "undefined" && "getDigitalGoodsService" in window;
}

async function service() {
  return window.getDigitalGoodsService(STORE);
}

export async function getProducts() {
  if (!isAppBilling()) return [];
  try {
    const svc = await service();
    return (await svc.getDetails(ALL_SKUS)) || [];
  } catch (e) {
    console.warn("Play Billing getDetails failed", e);
    return [];
  }
}

export async function hasActiveSubscription() {
  if (!isAppBilling()) return false;
  try {
    const svc = await service();
    const purchases = (await svc.listPurchases()) || [];
    return purchases.some((p) => ALL_SKUS.includes(p.itemId));
  } catch (e) {
    console.warn("Play Billing listPurchases failed", e);
    return false;
  }
}

export async function purchase(sku) {
  if (!isAppBilling()) throw new Error("not-in-app");
  const methodData = [{ supportedMethods: STORE, data: { sku } }];
  const details = { total: { label: "Total", amount: { currency: "USD", value: "0" } } };
  const request = new PaymentRequest(methodData, details);
  const response = await request.show();
  const token = response.details?.purchaseToken || response.details?.token;
  await response.complete("success");
  // Best-effort client acknowledgement (Digital Goods v1). For production,
  // acknowledge server-side via the Play Developer API to avoid auto-refunds.
  try {
    const svc = await service();
    if (typeof svc.acknowledge === "function") await svc.acknowledge(token, "onetime");
  } catch (e) {
    console.warn("Play Billing acknowledge failed (server-side ack recommended)", e);
  }
  return token;
}
